import styled from "@emotion/styled";
import {Flex} from "antd";

export const ButtonsWrapper = styled(Flex)`
  gap: 8px;
  padding-top: 36px;
  justify-content: flex-end;
`;
